// extracted by mini-css-extract-plugin
export var clauseRow = "_f2-6";
export var emptyState = "_f2-d";
export var filterContent = "_f2-a";
export var filterGroup = "_f2-1";
export var filterGroupContainer = "_f2-0";
export var nestedGroup = "_f2-2";
export var nestedGroupContent = "_f2-b";
export var nestedGroupDepth1 = "_f2-3";
export var nestedGroupDepth2 = "_f2-4";
export var nestedGroupDepth3 = "_f2-5";
export var nestedGroupEmpty = "_f2-c";
export var operatorAnd = "_f2-8";
export var operatorOr = "_f2-9";
export var operatorToggle = "_f2-7";
export var removeGroupButton = "_f2-e";